import { Component, OnInit, TemplateRef } from '@angular/core';
import { Sidebar } from 'src/app/shared';
import { ItemService } from 'src/app/shared/services/item/item.service';
import { SettingService } from 'src/app/shared/services/setting/setting.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
// import { saveAs } from "file-saver";
import { ItemModel } from "src/app/shared/models/item/item.modal";
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.scss']
})
export class ItemsComponent implements OnInit {
  public loading: boolean = false;
  public items: any[] = null;
  public env = environment;
  public zip_url: string = null;
  public Search = this.fb.group({
    item_number: ['',Validators.required],
  })
  public ItemModal: ItemModel = new ItemModel();
  public showWidget = this.fb.group({
    show_in_widget: [false]
  }) 
  public submitted: boolean = false;
  modelRef: BsModalRef;
  constructor(
    public _sidebar: Sidebar,
    public ItemService: ItemService,
    public SettingService:SettingService,
    public fb: FormBuilder,
    public toastr: ToastrService,
    public modelService: BsModalService,
  ) {
    
    this.getItemList();
  }
  tI
  ngOnInit() {
    window.scroll(0, 0);
  }

  getItemList() {
    this.loading = true;
    this.ItemService.GetItemList()
      .subscribe((result) => {
        if (result['success']) {
          this.loading = false;
          this.items = result['data'];

          for(let [index,item] of Object.entries(this.items)) {
            this.ItemModal.show_in_widget = result["data"][index].show_in_widget;
            this.ItemModal.item_id = result["data"][index].item_id;
          }
        }
        else {
          this.items  = null;
          this.loading = false;
        }
      }
      , (err:HttpErrorResponse) => {
        this.loading = false;
        if(err.error.message == 'Unauthenticated.' || err.status == 401 || err.statusText == "Unauthorized"){
          this.SettingService.LogOut();
        }
      }
    )
  }

  Clear(){
    this.Search.get('item_number').setValue('');
    this.Search.updateValueAndValidity();
    this.getItemList();
      
  }
  ClearInput(){
    if(this.Search.value.item_number == '' || this.Search.value.item_number == null){
      this.getItemList();
    }else{
      this.SearchItem();
    }
   
  }

  SearchItem(){
    
    if(this.Search.invalid){
      this.toastr.error('Please provide product number');
      return;
    }
    this.ItemService.ItemSearch(this.Search.value).subscribe(
      result=>{
        
        if(result['success']){
          this.items = result['data'];                  

        }else{
          // this.toastr.warning(result['msg']+' Provide valid Product Number')
          this.loading = false;
          this.items = null
        }
      }
    )
  }

  public downloadCSVform = this.fb.group({
    start_date: ["", Validators.required],
    end_date: [""]
  });

  get csvForm() {
    return this.downloadCSVform.controls;
  }

  exportCSV(template: TemplateRef<any>) {
    this.submitted = false;
    this.modelRef = this.modelService.show(template);
    this.downloadCSVform.get('start_date').setValue('');
  }

  exportItemCSV() {
    this.submitted  = true;
    if(this.downloadCSVform.invalid){
      return;
    }
    let data = {
      end_date: this.downloadCSVform.get('start_date').value[1],
      start_date: this.downloadCSVform.get('start_date').value[0]
    }
    // this.loading = true;
    this.ItemService.exportCSV(data)
      .subscribe((result) => {
        if (result['success']) {
          this.zip_url = "http://128.199.25.224/invoice-app-server/public/product/service.zip";
          const link = document.createElement('a');
          link.href =  this.zip_url ;
          link.download = this.zip_url ;
          link.click();
          this.modelRef.hide();
        }
      }
      , (err:HttpErrorResponse) => {
        this.loading = false;
        if(err.error.message == 'Unauthenticated.' || err.status == 401 || err.statusText == "Unauthorized"){
          this.SettingService.LogOut();
        }
      }
    )
  }

  showItemInWidget(evt,item) {
    let data = {
      item_id: item.item_id,
      show_in_widget: evt.target.checked
    }
    
    this.ItemService.showItemInWidget(data).subscribe((result) => {
      if (result['success']){
        this.showSuccess(result["msg"]);
      } else {
        this.showDanger(result["msg"]);
      }
    }),
    (err: HttpErrorResponse) => {
      if (
        err.error.message == "Unauthenticated." ||
        err.status == 401 ||
        err.statusText == "Unauthorized"
      ) {
        this.SettingService.LogOut();
      }
    }
  }

  showSuccess(msg: string) {
    this.toastr.success(msg);
  }

  showDanger(msg: string) {
    this.toastr.error(msg);
  }
}
